import React, { useEffect, useState } from 'react'
import {useNavigate} from "react-router-dom";
import {images} from "../../assets";
import { path } from '../../utils/const'

import style from "../consultation/consultation.module.css";
import css from "../pendingApproval/pending.module.css";
import { database } from '../../utils/firebase'
import moment from 'moment'

const PastConsultationDetail = () => {
  const [age, setAge] = useState(0);
  const [name, setName] = useState("");
  const [gender, setGender] = useState("");
  const [healthCardNumber, setHealthCardNumber] = useState("");

  const [patient, setPatient] = useState({});
  const [archiveData, setArchiveData] = useState([]);
  const [medications, setMedications] = useState([]);
  const [pharmacyData, setPharmacyData] = useState([]);
  const [delegateConvoData, setDelegateConvoData] = useState({});

  const navigate = useNavigate();
  const patientId = query.get('Id')
  const past = query.get('Past')
  const archiveId = query.get('archiveId')

  useEffect(async () => {
    try {
      const patientSnapshot = await database.ref(`/users/${patientId}`).once("value");
      const patientData = patientSnapshot.toJSON() || {};
      setPatient(patientData)
      let date = moment(patientData.DOB, "MMMM DD YYYY");
      let years = moment().diff(date, 'years');
      setAge(years)
      setName(patientData.name || patientData.userName || "")
      setGender(patientData.gender || "")
      setHealthCardNumber(patientData.healthInsuranceCardNumber || "")
      // eslint-disable-next-line no-shadow
      const pharmacyData = patientSnapshot.pharmacy || {};
      setPharmacyData(pharmacyData)

      let archiveSnapshot = await database.ref(`/archiveConversations/${archiveId}`).once("value");
      if (!archiveSnapshot.exists()) {
        archiveSnapshot = await database.ref(`/openconversations/${archiveId}`).once("value");
      }
      const archiveConversationsData = archiveSnapshot.toJSON() || {};
      setArchiveData(archiveConversationsData)
      if (archiveConversationsData.owner && patientData.profiles && patientData.profiles[archiveConversationsData.owner]) {
        date = moment(patientData.profiles[archiveConversationsData.owner].DOB, "MMMM DD YYYY");
        years = moment().diff(date, 'years');
        setAge(years)
        setName(patientData.profiles[archiveConversationsData.owner].name || patientData.profiles[archiveConversationsData.owner].userName || "")
        setGender(patientData.profiles[archiveConversationsData.owner].gender || "")
        setHealthCardNumber(patientData.profiles[archiveConversationsData.owner].healthInsuranceCardNumber || "")
      }
      if (archiveConversationsData.prescriptionData) {
        setMedications(Object.values(archiveConversationsData.prescriptionData?.medications || {}))
      } else {
        setMedications([])
      }
      const delegateSnapshot = await database.ref(`/delegateChats/${archiveId}`).once("value");
      const delegateConversationsData = delegateSnapshot.toJSON() || {};
      console.log("delegateConversationsData ", delegateConversationsData)
      setDelegateConvoData( delegateConversationsData )
    }catch (e) {
      console.log(e)
    }


  },[]);

  const viewPerscription = () => {
    navigate(path.viewprescription);
  }

  const navigateTo = () => {
    navigate(path.pastconsultationpage);
  }

  const navigateToChat =(id)=>{
    query.set('Id',id)
    query.set("delegateConversationID", delegateConvoData.conversationID)
    const chatPath=path.ChatModule
    const paramsString = query.toString();
    const url = new URL(window.location.href);
    url.search = paramsString;
    navigate(chatPath + url.search);
    // navigate("ChatModule")
  }

  return (
    <div>
      <div className={style.consultation}>
        <div className="d-flex">
          <button type="button" onClick={navigateTo}>
            <img src={images.backbutton} className={style.icon} alt="logo"/>
          </button>
          <p>Consultation</p>
        </div>

      </div>
      <div className={style.line}></div>
      <div className={style.patient}>
        <div>
          <span className={css.bold}>{archiveData.patientName || name}-</span>
          <span>{age} years old</span>
        </div>
      </div>
      <hr className={css.hr}></hr>

      <div className={style.iconAlign}>
        {delegateConvoData.conversationID? <button className={style.backgroundMessage} onClick={(event) =>navigateToChat(patientId, delegateConvoData.conversationID)}>
          <img src={images.chatIcon}  className={style.chatIcon}  alt="logo"/>
        </button>:<button className={style.backgroundMessage} >
          <img src={images.chatInactiveIcon} className={style.chatIcon}  alt="logo"/>
        </button>}
        <button className={style.backgroundCall}>
          <img src={images.phoneIcon} className={style.chatIcon} alt="logo"/>
        </button>
        <button className={style.backgroundCall}>
          <img src={images.videoIcon} className={style.chatIcon} alt="logo"/>
        </button>
      </div>

      <div className={style.patientInformationRoot}>
        <div className={style.patientInformation}>
          <span>Patient</span>
          <span>{archiveData.patientName || name}</span>

          <span>Issue</span>
          <span>{archiveData.issue}</span>

          <span>Gender</span>
          <span>{gender}</span>

          <span>Age</span>
          <span>{age} years old</span>

          <span>Date</span>
          <span>{moment(archiveData.timestamp).format("DD / MM / YYYY")}</span>

          <span>Phone number</span>
          <span>{patient.phone_number}</span>

          <span>State</span>
          <span>{patient.state}</span>

          <span>Health card #</span>
          <span>{healthCardNumber}</span>

        </div>
        <hr  className={style.hr}></hr>

        <div className={style.subjective}>
          <span>Subject symptoms</span>
          <p className={style.paragraph}>{archiveData?.symptoms || delegateConvoData.symptoms || ""}</p>

          <span>Objective findings</span>
          <p className={style.paragraph}>{archiveData?.findings || delegateConvoData.findings || ""}</p>

          <span>Assessment</span>
          <p className={style.paragraph}>{archiveData?.assessment || delegateConvoData.assessment || ""}</p>

          <span>Plan</span>
          <p className={style.paragraph}>{archiveData?.plan || delegateConvoData.plan || ""}</p>

        </div>
      </div>

      <div className={style.buttonDiv}>
        <button className={style.pastConsultationbutton} onClick={viewPerscription} >View prescriptions</button>
        <button className={style.pastConsultationbutton}>View sick notes</button>
        <button className={style.pastConsultationbutton}>View lab reports</button>
        <button className={style.endButton}>End consultation</button>
      </div>

    </div>
  )
}
export default PastConsultationDetail
